// put global constants here

// *************************************************************
// APIs
// *************************************************************
const getAccountsApi = () =>
  process.env[
    `REACT_APP_ACCOUNTS_API_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getAccountsApiKey = () =>
  process.env[
    `REACT_APP_ACCOUNTS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const API_URL_ACCOUNTS = getAccountsApi();
export const API_KEY_ACCOUNTS = getAccountsApiKey();

const getBuildersApi = () =>
  process.env[
    `REACT_APP_BUILDERS_API_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getBuildersApiKey = () =>
  process.env[
    `REACT_APP_BUILDERS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];

export const getContentfulSpaceId = () =>
  process.env.REACT_APP_CONTENTFUL_SPACE_ID;
export const getContentfulApiKey = () =>
  process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

export const API_URL_BUILDERS = getBuildersApi();
export const API_KEY_BUILDERS = getBuildersApiKey();

export const LOGIN_API = `${API_URL_ACCOUNTS}/login`;

export const LOGOUT_API = `${API_URL_ACCOUNTS}/logout/my-build`;

export const FORGOT_PASSWORD_API = `${API_URL_ACCOUNTS}/forgot-password/my-build`;

export const RESET_PASSWORD_API = `${API_URL_ACCOUNTS}/reset-password/my-build`;

export const SIGN_UP_API = `${API_URL_ACCOUNTS}/sign-up`;

export const GET_USER_PROFILE_API = `${API_URL_ACCOUNTS}/user`;

export const UPDATE_USER_PROFILE_API = `${API_URL_ACCOUNTS}/user`;

export const EMAIL_UNIQUE_CHECK_API = `${API_URL_ACCOUNTS}/email-unique`;

export const GET_SKILLSET_OPTIONS_API = `${API_URL_ACCOUNTS}/skillset`;

export const USER_JOBS_API = `${API_URL_BUILDERS}/users/me/jobs`;

export const USER_ACCEL_SESSIONS_API = `${API_URL_BUILDERS}/users/me/accelSessions`;

export const RESEND_VERIFICATION_EMAIL_API = `${API_URL_ACCOUNTS}/resend-confirmation-email`;

export const GET_USER_BUSINESSES_API = `${API_URL_BUILDERS}/users/me/businesses`;

export const USER_BUSINESSES_API = `${API_URL_BUILDERS}/users/me/businesses`;

export const AUTHORISE_BUILDER_ENDPOINT_URL = `${API_URL_BUILDERS}/businesses/approve`;

export const ACTIVITY_LOG_API = `${API_URL_BUILDERS}/activityLog`;

export const PARDOT_SIGNUP_REQUEST =
  'https://www2.jameshardie.com.au/l/53212/2021-01-17/kxdw2p';

export const UPLOAD_API = `${API_URL_BUILDERS}/builders/upload`;

// *************************************************************

const getGoogleMapsApiKey = () =>
  process.env[
    `REACT_APP_GOOGLE_MAPS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];
export const GOOGLE_MAPS_API_KEY = getGoogleMapsApiKey();

export const LOG_ROCKET_APP_ID = '5iqnpc/jh_mybuild';

const getGoogleTagMangEnv = () =>
  process.env[
    `REACT_APP_GOOGLE_TAG_MANAGER_ENV_${
      process.env.REACT_APP_API
    }`.toUpperCase()
  ];

const getGoogleTagMangEAuth = () =>
  process.env[
    `REACT_APP_GOOGLE_TAG_MANAGER_AUTH_${
      process.env.REACT_APP_API
    }`.toUpperCase()
  ];

export const GOOGLE_TAG_MANAGER_ID = 'GTM-5P8ZV9Z';
export const GOOGLE_TAG_MANAGER_ENV = getGoogleTagMangEnv();
export const GOOGLE_TAG_MANAGER_AUTH = getGoogleTagMangEAuth();

// *************************************************************
// Base URLs
// *************************************************************
const getConsumerSiteBaseUrl = () =>
  process.env[
    `REACT_APP_CONSUMER_SITE_BASE_URL_${
      process.env.REACT_APP_API
    }`.toUpperCase()
  ];
export const CONSUMER_SITE_BASE_URL = getConsumerSiteBaseUrl();

// *************************************************************
// Accel
// *************************************************************
export const getAccelUrl = type =>
  process.env[`REACT_APP_${type}`.toUpperCase()];

export const ACCEL_URL = {
  ACCEL_PRODUCT_GUIDES: 'ACCEL_PRODUCT_GUIDES',
  ACCEL_INSTALLATION_ADVICE: 'ACCEL_INSTALLATION_ADVICE',
  ACCEL_BUSINESS_TOOLS: 'ACCEL_BUSINESS_TOOLS',
};

// *************************************************************
// Colours
// *************************************************************
export const COLORS = {
  GREY_LIGHTER: '#DEE6E6',
  GREY_LIGHT: '#a7a9ab',
  GREY: '#dfe3e6',
  GREY_DARK: '#4D4D4D',
  GREY_DARK2: '#A0A3AC',
  GREY_DARKER: '#333333',
  WHITE: '#FFFFFF',
  WHITE_DARK: '#fbfcfc',
  BLUE: '#2090fb',
  BLUE_LIGHT: '#86bbe6',
  BLUE_DARK: '#4390F3',
  BLACK: '#000000',
  GREEN: '#009a44',
  GREEN_0: '#00833E',
  GREEN_LIGHT: '#83be52',
  RED: '#f44336',
  YELLOW_DARK: '#f5a623',
  PURPLE: '#343B4D',
};

// *************************************************************
// Fonts
// *************************************************************
export const FONTS = {
  PRIMARY: '"Helvetica Neue", Arial',
  SECONDARY: '"Montserrat", Arial',
  THIRD: '"CasualDe", Arial',
};

// *************************************************************
// Modals
// *************************************************************
export const REGISTRATION_MODAL_REFERRER = {
  LINK: 'link',
  LOGIN_FAILURE: 'login-failure',
};

// *************************************************************
// Forms
// *************************************************************
export const FORMS = {
  REGISTRATION_LONG: 'registration-long-form',
  REGISTRATION_SHORT: 'registration-short-form',
  BUILDER_PROFILE_PERSONAL: 'builder-profile-personal',
  BUILDER_PROFILE_BUSINESS: 'builder-profile-business',
  BUILDER_LICENSE_EXPIRY: 'builder-license-expiry',
  UPDATE_SERVICE_AREA: 'update-service-area',
  JOB_FORM: 'job-form',
  RESEND_VERIFICATION_EMAIL_FORM: 'resend-verification-email-form',
  BUILDER_PROFILE_ADDITIONAL: 'builder-profile-additional',
};

export const VIEWABLE_FORM_MODES = {
  EDITING: 'editing',
  VIEWING: 'viewing',
};

// *************************************************************
// User Profile Type
// *************************************************************
export const USER_PROFILE_TYPES = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  SERVICE_AREA: 'service_area',
  ADDITIONAL: 'additional',
};

// *************************************************************
// Role Types
// *************************************************************
export const USER_ROLE_TYPES = {
  ARCHITECT: {
    code: 'A',
    displayLabel: 'Architect',
  },
  BUILDER: {
    code: 'B',
    displayLabel: 'Builder',
  },
  CERTIFIER: {
    code: 'CT',
    displayLabel: 'Certifier',
  },
  DESIGNER: {
    code: 'S',
    displayLabel: 'Designer',
  },
  DISTRIBUTOR: {
    code: 'D',
    displayLabel: 'Distributor',
  },
  ENGINEER: {
    code: 'E',
    displayLabel: 'Engineer',
  },
  INSTALLER: {
    code: 'I',
    displayLabel: 'Installer',
  },
  JH_STAFF: {
    code: 'J',
    displayLabel: 'James Hardie Staff',
  },
  BUILDING_DESIGNER: {
    code: 'BD',
    displayLabel: 'Building Designer',
  },
  CONTRACTOR: {
    code: 'CO',
    displayLabel: 'Contractor',
  },
  DEVELOPER: {
    code: 'DEV',
    displayLabel: 'Developer',
  },
  HOME_OWNER: {
    code: 'HO',
    displayLabel: 'Home Owner',
  },
  RENOVATOR: {
    code: 'RE',
    displayLabel: 'Renovator',
  },
  OTHER: {
    code: 'O',
    displayLabel: 'Other',
  },
};

export const PARDOT_ROLE_TYPE_MAP = {
  B: 'Builder',
  S: 'Building Designer',
  D: 'Channel Partner',
  A: 'Architect',
  O: 'Other',
  I: 'Contractor',
  BD: 'Building Designer',
  C: 'Contractor',
  DEV: 'Developer',
  HO: 'Home Owner',
  RE: 'Renovator',
};

export const ACCEL_ROLE_TYPES = [
  USER_ROLE_TYPES.ARCHITECT.code,
  USER_ROLE_TYPES.CERTIFIER.code,
  USER_ROLE_TYPES.DESIGNER.code,
  USER_ROLE_TYPES.DISTRIBUTOR.code,
  USER_ROLE_TYPES.ENGINEER.code,
  USER_ROLE_TYPES.INSTALLER.code,
  USER_ROLE_TYPES.JH_STAFF.code,
  USER_ROLE_TYPES.BUILDING_DESIGNER.code,
  USER_ROLE_TYPES.CONTRACTOR.code,
  USER_ROLE_TYPES.DEVELOPER.code,
  USER_ROLE_TYPES.HOME_OWNER.code,
  USER_ROLE_TYPES.RENOVATOR.code,
];

export const USER_ROLE_TYPES_LIST = [
  USER_ROLE_TYPES.ARCHITECT,
  USER_ROLE_TYPES.BUILDER,
  USER_ROLE_TYPES.BUILDING_DESIGNER,
  USER_ROLE_TYPES.CONTRACTOR,
  USER_ROLE_TYPES.DEVELOPER,
  USER_ROLE_TYPES.HOME_OWNER,
  USER_ROLE_TYPES.RENOVATOR,
  // USER_ROLE_TYPES.CERTIFIER,
  // USER_ROLE_TYPES.DESIGNER,
  // USER_ROLE_TYPES.DISTRIBUTOR,
  // USER_ROLE_TYPES.ENGINEER,
  // USER_ROLE_TYPES.INSTALLER,
  // USER_ROLE_TYPES.JH_STAFF,
  USER_ROLE_TYPES.OTHER,
];

// *************************************************************
// Notification levels
// *************************************************************
export const NOTIFICATON_LEVELS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

// *************************************************************
// Job Statuses
// *************************************************************
export const JOB_STATUS_CODES = {
  STATUS_01: 1,
  STATUS_02: 2,
  STATUS_03: 3,
  STATUS_04: 4,
};

// *************************************************************
// Sort Directions
// *************************************************************
export const SORT_DIRECTIONS = {
  ASC: 'ascending',
  DESC: 'descending',
};

// *************************************************************
// Service Areas
// *************************************************************
export const SERVICE_AREAS = {
  LOCAL: 'local',
  STATEWIDE: 'statewide',
  NATIONAL: 'national',
};

export const LOCAL_SERVICE_AREA_RADIUS_KM = 30;

// *************************************************************
// Geography
// *************************************************************
export const SOUTH_POLE = {
  lat: -88,
  lng: -99,
};

export const AUS_CENTER = {
  lat: -30,
  lng: 133,
};

export const AUS_STATES = [
  {
    short_name: 'NSW',
    long_name: 'New South Wales',
    center_location: {
      lat: -33,
      lng: 147,
    },
    zoom_level: 6,
  },
  {
    short_name: 'QLD',
    long_name: 'Queensland',
    center_location: {
      lat: -20,
      lng: 145,
    },
    zoom_level: 5,
  },
  {
    short_name: 'ACT',
    long_name: 'Australian Capital Territory',
    center_location: {
      lat: -35.5,
      lng: 149,
    },
    zoom_level: 9,
  },
  {
    short_name: 'VIC',
    long_name: 'Victoria',
    center_location: {
      lat: -37,
      lng: 144,
    },
    zoom_level: 6,
  },
  {
    short_name: 'TAS',
    long_name: 'Tasmania',
    center_location: {
      lat: -42,
      lng: 146,
    },
    zoom_level: 7,
  },
  {
    short_name: 'SA',
    long_name: 'South Australia',
    center_location: {
      lat: -31,
      lng: 135,
    },
    zoom_level: 5,
  },
  {
    short_name: 'WA',
    long_name: 'Western Australia',
    center_location: {
      lat: -26,
      lng: 120,
    },
    zoom_level: 5,
  },
  {
    short_name: 'NT',
    long_name: 'Northern Territory',
    center_location: {
      lat: -18,
      lng: 134,
    },
    zoom_level: 5,
  },
];

// *************************************************************
// Login screens
// *************************************************************
export const LOGIN_SCREENS = {
  VERIFICATION: 'verification',
  NORMAL: 'normal',
  FORGOT_PASSWORD: 'forgotPw',
  NEW_PASSWORD: 'newPw',
  NEW_PASSWORD_SUCCESS: 'newPwSuccess',
  RESEND_VERIFICATION_EMAIL: 'resendVerificationEmail',
};

export const IMAGE_SIZE_LIMIT = 5 * 1000 * 1024; // 5mb
export const IMAGE_SIZE_LIMIT_MESSAGE =
  'File is too big!, Maximum allowed size is 5 MB';

export const FILE_TYPE_ERROR = 'Only image files are supported';

export const BUILDER_DEACTIVATE_REASONS = [
  { name: 'Invalid', value: 'Invalid' },
  { name: 'Does not want leads', value: 'Does not want leads' },
  { name: 'Temporarily paused', value: 'Temporarily paused' },
  { name: 'Others', value: 'Others' },
];
